import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAnalytics } from '../context/AnalyticsContext';
import { trackEvents, trackStickerDesign } from '../utils/analytics';

export default function Cancel() {
  const { analytics } = useAnalytics();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (analytics) {
      // Use trackStickerDesign with the correct CHECKOUT_ABANDONED event
      trackStickerDesign(analytics, trackEvents.CHECKOUT_ABANDONED, {
        order_id: orderId || undefined,
        session_id: sessionId || undefined,
        status: 'cancelled',
        cancellation_reason: 'user_initiated',
        timestamp: new Date().toISOString()
      });
    }
  }, [analytics, orderId, sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Order Cancelled
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Your order has been cancelled. No payment has been processed.
          </p>
        </div>
        <div className="mt-8">
          <Link
            to="/"
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Return to Designer
          </Link>
        </div>
      </div>
    </div>
  );
}